module.exports = __webpack_public_path__ + "img/product_logo.b5a316e6.png";